/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSupervisorEntryResponsePhotoBlobPath } from './oralExamSupervisorEntryResponsePhotoBlobPath';
import type { OralExamSupervisorEntryResponseVisit } from './oralExamSupervisorEntryResponseVisit';
import type { OralExamSupervisorEntryResponseDisplayName } from './oralExamSupervisorEntryResponseDisplayName';

/**
 * One supervisor on the time-slot roster (wire projection of SupervisorEntryDb).
 */
export interface OralExamSupervisorEntryResponse {
  lecturerId: string;
  joinedAt: string;
  connected?: boolean;
  photoBlobPath?: OralExamSupervisorEntryResponsePhotoBlobPath;
  visit?: OralExamSupervisorEntryResponseVisit;
  displayName?: OralExamSupervisorEntryResponseDisplayName;
}
